import { createSlice } from '@reduxjs/toolkit';
import { 
  fetchSchedules, 
  fetchScheduleById, 
  createSchedule, 
  updateSchedule, 
  deleteSchedule,
  activateSchedule,
  deactivateSchedule
} from '../thunks/schedulesThunks';

const initialState = {
  schedules: [],
  currentSchedule: null,
  loading: false,
  error: null,
};

const schedulesSlice = createSlice({
  name: 'schedules',
  initialState,
  reducers: {
    clearScheduleError: (state) => {
      state.error = null;
    },
    clearCurrentSchedule: (state) => {
      state.currentSchedule = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchedules.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSchedules.fulfilled, (state, action) => {
        state.loading = false;
        state.schedules = action.payload;
      })
      .addCase(fetchSchedules.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      
      .addCase(fetchScheduleById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchScheduleById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentSchedule = action.payload;
      })
      .addCase(fetchScheduleById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      
      .addCase(createSchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.schedules.push(action.payload);
        state.currentSchedule = action.payload;
      })
      .addCase(createSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      
      .addCase(updateSchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.schedules = state.schedules.map(schedule => 
          schedule.id === action.payload.id ? action.payload : schedule
        );
        state.currentSchedule = action.payload;
      })
      .addCase(updateSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      
      .addCase(deleteSchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.schedules = state.schedules.filter(schedule => schedule.id !== action.payload);
        if (state.currentSchedule && state.currentSchedule.id === action.payload) {
          state.currentSchedule = null;
        }
      })
      .addCase(deleteSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      
      .addCase(activateSchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(activateSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.schedules = state.schedules.map(schedule => 
          schedule.id === action.payload.id ? action.payload : schedule
        );
        if (state.currentSchedule && state.currentSchedule.id === action.payload.id) {
          state.currentSchedule = action.payload;
        }
      })
      .addCase(activateSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      
      .addCase(deactivateSchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deactivateSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.schedules = state.schedules.map(schedule => 
          schedule.id === action.payload.id ? action.payload : schedule
        );
        if (state.currentSchedule && state.currentSchedule.id === action.payload.id) {
          state.currentSchedule = action.payload;
        }
      })
      .addCase(deactivateSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearScheduleError, clearCurrentSchedule } = schedulesSlice.actions;
export default schedulesSlice.reducer;
